export default "__VITE_ASSET__9f2e0410__"